import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getPoint, resetPoint } from '../../store/actions/point';
import { getPlace, resetPlace } from '../../store/actions/place';
import { navigateSpace } from '../../store/actions/app';
import { PointSpace } from '../../containers/xr/space';
import { RootState } from '../../types/data';
import { PLACE_LOADED } from '../../common/constants/gateway-events';
import GatewayService from '../../services/gateway-service';
import { Helmet } from 'react-helmet';
import { useActions } from '../../hooks';
import axios from 'axios';

type TPlaceRouteReduxState = {
  place: RootState['place']['current'];
};

const PlaceRoute = () => {
  const { placeId } = useParams<{ placeId?: string }>();
  const { place } = useSelector<RootState, TPlaceRouteReduxState>(state => ({ place: state.place.current }));
  const boundActions = useActions({
    getPlace,
    resetPlace,
    getPoint,
    resetPoint,
    navigateSpace,
  });

  // data fetching functional
  useEffect(() => {
    if (!placeId) return;

    // create the source
    const reqSource = axios.CancelToken.source();

    (async () => {
      const {
        __HANDLED_ERROR__,
        payload: {
          data: { response: res },
        },
      } = await ((boundActions.getPlace(placeId, reqSource.token) as unknown) as Promise<any>);

      if (__HANDLED_ERROR__) return;

      const {
        __HANDLED_ERROR__: P__HANDLED_ERROR__,
        payload: {
          data: { response },
        },
      } = await ((boundActions.getPoint(res.point_id, reqSource.token) as unknown) as Promise<any>);
      if (!P__HANDLED_ERROR__) {
        boundActions.navigateSpace(response);
      }
    })();

    return () => {
      reqSource.cancel('Point changed.');
      boundActions.resetPlace();
    };
  }, [boundActions, placeId]);

  useEffect(() => {
    if (place.loaded && place.data) {
      GatewayService.emit(PLACE_LOADED, place.data);
    }
  }, [place.loaded, place.data]);

  const pageTitle = place.data?.title;

  return (
    <>
      <Helmet>{pageTitle ? <title>{`${pageTitle} | 360 Stories`} </title> : null}</Helmet>
      <PointSpace />
    </>
  );
};

export default PlaceRoute;
